import React from 'react';
import PropTypes from 'prop-types';

export default function ProjectModal({ project, onClose }) {
  const Icon = project.Icon;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="project-modal-icon-container">
          <div className="project-modal-icon"><Icon /></div>
        </div>
        <span className="modal-category">{project.category === 'tech' ? 'Tech Solution' : 'Non-Tech Solution'}</span>
        <h3>{project.title}</h3>
        <p style={{ fontSize: '1.125rem', lineHeight: '1.8', color: 'var(--text-dark)', marginTop: '1rem' }}>{project.description}</p>

        <div style={{ marginTop: '2rem' }}>
          <h4 style={{ marginBottom: '0.5rem' }}>Technologies/Tools Used</h4>
          <p className="project-tech">{project.tech}</p>
        </div>

        <div style={{ marginTop: '2rem' }}>
          <h4 style={{ marginBottom: '1rem' }}>Project Highlights</h4>
          <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem', color: 'var(--text-dark)', lineHeight: '1.8' }}>
            <li>Delivered on time and within budget</li>
            <li>Exceeded client expectations</li>
            <li>Scalable and maintainable solution</li>
            <li>Ongoing support and updates</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

ProjectModal.propTypes = {
  project: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};
